import { useCallback, useEffect, useRef, useState } from 'react';
import { supabase } from '../lib/supabase';
import { buscarHistoricoDesconto, type RegistroDesconto } from '../lib/descontoHistorico';

// Histórico do desconto de uma UC (ver src/lib/descontoHistorico.ts). Falha na
// leitura não trava a tela: fica a lista vazia e o erro, para a tela avisar.
export function useHistoricoDesconto(ucId: number | string | null | undefined) {
    const [registros, setRegistros] = useState<RegistroDesconto[]>([]);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState<string | null>(null);
    // Troca de UC com uma leitura em voo (fila de cálculo): só a última resposta vale.
    const pedido = useRef(0);

    const recarregar = useCallback(async () => {
        const meu = ++pedido.current;
        if (!ucId) {
            setRegistros([]);
            setErro(null);
            return;
        }
        setCarregando(true);
        try {
            const lista = await buscarHistoricoDesconto(supabase, ucId);
            if (meu !== pedido.current) return;
            setRegistros(lista);
            setErro(null);
        } catch (e: any) {
            if (meu !== pedido.current) return;
            setRegistros([]);
            setErro(e?.message || 'Não foi possível ler o histórico do desconto.');
        } finally {
            if (meu === pedido.current) setCarregando(false);
        }
    }, [ucId]);

    useEffect(() => { recarregar(); }, [recarregar]);

    return { registros, carregando, erro, recarregar };
}
